import { render, staticRenderFns } from "./franchisee-bills.vue?vue&type=template&id=2cc366e5&scoped=true&"
import script from "./franchisee-bills.vue?vue&type=script&lang=js&"
export * from "./franchisee-bills.vue?vue&type=script&lang=js&"
import style0 from "./franchisee-bills.vue?vue&type=style&index=0&id=2cc366e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc366e5",
  null
  
)

export default component.exports